import React from 'react';
import { SVBErrorPageRenderer } from '../helpers/utilityFunctions';
import icon from '@svb/svbbranding/dist/assets/icons/icon-error.svg';

const PageNotFound = () => {
  return (
    <div className='container-fluid pt-5 mt-2 '>
      <SVBErrorPageRenderer
        title={'Something went wrong'}
        errorStatusCode={'404'}
        icon={icon}
        navigateToLink='/'
        btnText={'Go Home'}
      />
    </div>
  );
};

export default PageNotFound;
